export const iconFontAwesomeGamingChessQueen = (
	<i className="fa-solid fa-chess-queen"></i>
);
